import { Head, router } from "@inertiajs/react";
import { useModalStack } from "@inertiaui/modal-react";
import { t } from "@travily/i18n";
import { accountPayoutsResumptionPath, newAccountPayoutsPath } from "@travily/routes";
import type CreatorListingsIndex from "@travily/types/pages/CreatorListingsIndex";
import { useCallback } from "react";
import { PageFrame } from "@/layouts/page-frame";
import { IndexView } from "./index.view";

const CreatorListingsIndexPage = ({ products, services, payouts_status }: CreatorListingsIndex) => {
  const { visitModal } = useModalStack();

  const handleSetUpPayouts = useCallback(() => {
    visitModal(newAccountPayoutsPath());
  }, [visitModal]);

  const handleResumePayouts = useCallback(() => {
    router.post(accountPayoutsResumptionPath());
  }, []);

  return (
    <PageFrame mode="creator">
      <Head title={t("web.creator.listings.index.meta_title")} />
      <IndexView
        products={products}
        services={services}
        payoutsStatus={payouts_status}
        onSetUpPayouts={handleSetUpPayouts}
        onResumePayouts={handleResumePayouts}
      />
    </PageFrame>
  );
};

export default CreatorListingsIndexPage;
